import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24">
        <section className="py-24 bg-cream">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h1 className="font-serif text-6xl font-bold text-gray-900 mb-6">About Hudson Valley Trails</h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Your trusted guide to camping and RVing adventures in New York's beautiful Hudson Valley region.
            </p>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="font-serif text-4xl font-bold text-gray-900 mb-8">Our Story</h2>
            <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
              <p>
                Hudson Valley Trails was born from a passion for the great outdoors and a love for the stunning landscapes of New York's Hudson Valley. What started as weekend camping trips with friends has grown into a comprehensive resource for outdoor enthusiasts seeking authentic camping and RVing experiences.
              </p>
              <p>
                We've spent years exploring every corner of the Hudson Valley, from the majestic peaks of the Catskills to the serene shores of hidden lakes. Our team has camped in countless sites, driven thousands of miles in RVs, and hiked hundreds of trails to bring you the most accurate and helpful information.
              </p>
              <p>
                Our mission is simple: to help you discover the magic of camping in the Hudson Valley while providing practical tips, honest reviews, and insider knowledge that only comes from years of firsthand experience.
              </p>
            </div>
          </div>
        </section>

        <section className="py-20 bg-sage-light">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="font-serif text-4xl font-bold text-gray-900 mb-12 text-center">What We Offer</h2>
            <div className="grid grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-md">
                <div className="w-16 h-16 bg-forest/10 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-map-pin-line text-3xl text-forest"></i>
                </div>
                <h3 className="font-bold text-xl text-gray-900 mb-4">Destination Guides</h3>
                <p className="text-gray-600 leading-relaxed">
                  Detailed reviews and recommendations for the best camping and RV sites throughout the Hudson Valley.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-md">
                <div className="w-16 h-16 bg-forest/10 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-lightbulb-line text-3xl text-forest"></i>
                </div>
                <h3 className="font-bold text-xl text-gray-900 mb-4">Expert Tips</h3>
                <p className="text-gray-600 leading-relaxed">
                  Practical advice on gear, planning, safety, and making the most of your outdoor adventures.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-md">
                <div className="w-16 h-16 bg-forest/10 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-community-line text-3xl text-forest"></i>
                </div>
                <h3 className="font-bold text-xl text-gray-900 mb-4">Community Stories</h3>
                <p className="text-gray-600 leading-relaxed">
                  Real experiences from fellow campers and RVers who share their adventures and insights.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;